var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "guide-icon-3_svg__a",
    d: "M0 0h37.419v37.42H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.581)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "guide-icon-3_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#guide-icon-3_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.42 18.71c0 10.333-8.377 18.71-18.71 18.71S0 29.042 0 18.71 8.377 0 18.71 0s18.71 8.377 18.71 18.71",
    fill: "#F8D7CC",
    mask: "url(#guide-icon-3_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M5.807 5.806L.645 10.968v28.387h23.871V5.806z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    d: "M.645 11.613h5.807V5.806h-.645L.645 10.968z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.516 40H.646A.645.645 0 010 39.355V10.968c0-.172.068-.336.189-.456L5.35 5.35a.642.642 0 01.456-.189h18.71c.357 0 .645.289.645.645v12.259a.645.645 0 11-1.29 0V6.452H6.074L1.29 11.235V38.71h22.581v-7.097a.645.645 0 111.29 0v7.742a.645.645 0 01-.645.645",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.452 12.258H3.226a.645.645 0 110-1.29h2.58v-2.58a.645.645 0 111.29 0v3.225a.645.645 0 01-.644.645",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.606 18.193l-15.73 15.73-3.976.795.795-3.975 15.73-15.731a.796.796 0 011.125 0l2.056 2.056c.31.31.31.814 0 1.125",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.289 31.061l-.567 2.835 2.835-.567L34.15 17.736a.151.151 0 000-.212l-2.056-2.056a.151.151 0 00-.212 0L16.289 31.061zM14.9 35.364a.645.645 0 01-.633-.772l.796-3.976a.642.642 0 01.176-.33l15.73-15.73a1.442 1.442 0 012.037 0l2.057 2.056a1.442 1.442 0 010 2.037l-15.731 15.73a.651.651 0 01-.33.177l-3.976.795a.647.647 0 01-.126.013z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M32.327 20.472l-3.18-3.18.911-.913 3.181 3.18z"
  }))));
}
export default SvgGuideIcon3;